<style scoped>
.header-row-bg-div {
	/*margin-top:20px;*/
	/*margin-bottom:20px;*/
	padding-top:25px;
	padding-bottom:25px;
	/*background-color: #ee11ee;*/
	background-image: url(./Home134.png);
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

}
.header-row-text-div {
	margin-left: 10%;
	margin-right: 10%;
	margin-top:50px;
	margin-bottom:50px;
	/*border: 5px solid black;*/
	
}
.header-text {
	margin-left:20%;
	margin-right:20%;
	object-fit: contain;
}
.header-description {
	margin-top:50px;
	text-align: left;
	font-size: large;
	line-height: 180%;
}
.stat-row-bg-div {
	background-color: #f3f8e9;
	/*padding-top: 15px;
	padding-bottom: 15px;*/
	margin-bottom: 63px;
}
.stat-row-text-div {
	padding-top:25px;
	padding-bottom:25px;
	padding-left:0px;
	padding-right:0px;
	text-align: center;
	margin-left: calc(10% - 15px);
	margin-right: calc(10% - 15px);
	
}

.statisticsDiv {
	/*
	border-top: solid;
	border-bottom: solid;
	*/
	
}
.imgDiv {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100px;
	border: 10px solid #f3f8e9;
	
}
.imgSet {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.imgLargeWord {
	font-size: x-large;
	text-align: left;
	margin: 0;
}
.imgSmallWord {
	font-size: small;
	text-align: left;
}

.text-description-title {
	font-family: fantasy;
	font-size: larger;
	text-align: center;
}

.text-description-content {
	text-align: center;
}


.search-row {
	text-align: center;
}
.input-form {
	width:100%;
}
.input-text-area {
	border: #add26b solid 2px;
	width:calc(80% - 50px);
	height:50px;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	padding-left: 20px;
}
.search-button {
	background-color:#add26b;
	height:50px;
	width:50px;
	color:white;
	font-size:14pt;
	border: #add26b solid 2px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
}

.example-row {
	align:center;
	margin:auto;
}

.example-input {
	text-decoration: underline;
	color: #add26b;
	font-weight: bold;
	cursor: pointer;
}

</style>

<template>
	<div>
		<div class="header-row-bg-div" >
			<div class ="header-row-text-div">
				<div class="header-text">
					<img class="imgSet" src="Home2.png" />
				</div>		
				<div class="header-description">
					<p>NetFlow3D is a computational tool aiming at deciphering how somatic mutations function in cancer.  It specifically focuses on protein-altering mutations. By combining the insights from protein structure and protein-protein interaction network, NetFlow3D nominates potential driver mutations and map their functional effects on multiple scales. NetFlow3D web server allows the users to (i) browse and download the results generated from TCGA pan-cancer data, and (ii) run NetFlow3D on their own data. </p>
				</div>
			</div>
		</div>
		<div style="margin-bottom:20px">
			<b-col>
				<b-row class="search-row">
					<form class="input-form">
						<input class="input-text-area" type="text" v-model="userProteinQuery" placeholder="UniProt ID, Ensembl protein ID, and gene name are accepted.">
						<button class="search-button" type="submit" @click="sendQuery()"><i class="fa fa-search"></i></button>
					</form>
				</b-row>
				<b-row>
					<div class="example-row" style="margin-top:10px;">
						<label class="example-input" @click="userProteinQuery = 'PPP2R5B'">
							Example 1: PPP2R5B
						</label>
						|
						<label class="example-input" @click="userProteinQuery = 'INTS6'">
							Example 2: INTS6
						</label>
					</div>
				</b-row>					
			</b-col>
		</div>

		<!--
		<div>
		<b-container fluid style="border: 5px solid red; width=100%">
			<b-row>
			<b-col>
			A
			</b-col>
			</b-row>
		</b-container>
		</div>
		-->
		<div class="stat-row-bg-div">
			<div class ="stat-row-text-div" >

				<b-container fluid>
					<b-row >
						<template v-for="(imgWord, idx) in imgWordArray">
							<b-col :key="idx" style="margin:5px" >
								<b-row class="text-center" align-v="bottom" > <!--style="margin:0px; padding :0px"-->
									<b-col cols="6" style="padding :0px; ">
										<div class="imgDiv">
										<img :src="imgWord[0]" width="600" height="600" class="imgSet" />
										</div>
									</b-col>
									<b-col cols="6"> <!-- -->
										<div class="imgLargeWord">{{imgWord[1]}}</div>
										<div class="imgSmallWord">{{imgWord[2]}}</div>
									</b-col>
								</b-row>
							</b-col>
							<div class="w-100" :key="idx" v-if="(idx+1) % 5 == 0"></div>
						</template>
					</b-row>
				</b-container>
			</div>
		</div>
	</div>
</template>

<script>
//import axios from "axios";

export default {
	name: "Front",

	data() {
		return {
			imgWordArray: [
				["Home5.png", "146,352", "structures of\nsingle proteins"],
				["Home6.png", "119,526", "binding interfaces\nof known PPIs"],
				["Home7.png", "19", "cancer types"], 
				["Home8.png", "5,950", "tumor samples"],
				["Home9.png", "415,017", "somatic protein-\naltering mutations"],
				["Home10.png", "1,656", "intra-protein\nclusters"],
				["Home11.png", "3,343", "inter-protein\nclusters"],
				["Home12.png", "469", "LOF-enrichment signals"],
				["Home13.png", "377", "strongly connected\nsubnetworks"],
				["Home14.png", "44,521", "potentially\nfunctional mutations"],
			],
			userProteinQuery: "",
		};
	},
	computed: {
	},
	methods: {
		sendQuery() {
			this.$router.push({
				name: "database",
				params: { 
					"queryterm":this.userProteinQuery
				}
			});
		},
	}
	
};
</script>
